/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Ritik Gupta",
  title: "Hi all, I'm Ritik",
  subTitle: emoji(
    'Full Stack MERN Developer with 3+ years of experience'
    // "Results-driven Full Stack Developer with 3+ years of experience building scalable, high-performance web applications using React.js, Next.js, Node.js, MongoDB, and AWS. Passionate about creating seamless user experiences, robust backend systems, and AI-powered solutions that solve real-world problems. Experienced in delivering end-to-end products from concept to deployment with a strong focus on clean code, performance, and scalability."
  ),
  resumeLink: "https://drive.google.com/file/d/1Ka_1fu33iFrqXaQkd-SHcFfCwtRjfslX/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/codewithritik/",
  linkedin: "https://www.linkedin.com/in/ritik85/",
  gmail: "ritikadvice@gmail.com",
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"
    ),
    emoji("⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks"),
    emoji("⚡ Integration of third party services such as Firebase/ AWS / GCP")
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "bootstrap",
      fontAwesomeClassname: "fab fa-bootstrap"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "mongoDb",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "mysql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "jira",
      fontAwesomeClassname: "fab fa-jira"
    },
    {
      skillName: "bitbucket",
      fontAwesomeClassname: "fab fa-bitbucket"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Chandigarh University",
      logo: require("./assets/images/Chandigarh-logo.jpg"),
      subHeader: "Master in Computer Application",
      duration: "Jan 2024 - Jan 2026"
    },
    {
      schoolName: "Masai School",
      logo: require("./assets/images/masai.jpg"),
      subHeader: "Full-Stack Web Development Course",
      duration: "Nov 2021 - Jun 2022"
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Problem Solving", //Insert stack or technology you have experience in
      progressPercentage: "95%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Team Collaboration",
      progressPercentage: "85%"
    },
    {
      Stack: "Communication",
      progressPercentage: "80%"
    },
    {
      Stack: "Quick Learning",
      progressPercentage: "99%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Development Engineer 1",
      company: "Nineleaps Technology",
      companylogo: require("./assets/images/nineleaps_logo.jpg"),
      date: "Nov 2025 – Apr 2026",
      desc: 'Developed an AI-powered content generation system using OpenAI that enhanced UI personalization and reduced manual content effort by approximately 60%, while also integrating the Geidea payment gateway end-to-end to ensure secure transactions and improve checkout success rates through stable API implementation.'
    },
    {
      role: "Software Engineer",
      company: "Spaxa Solution Pvt Ltd",
      companylogo: require("./assets/images/Spraxa_logo.jpg"),
      date: "Feb 2023 – Apr 2025",
      desc: "Built and maintained scalable full-stack applications using React.js and Node.js, supporting 1000+ concurrent users across multiple product lines, improved system performance by 40% through query optimization and code refactoring, and led a team of 3–4 developers to accelerate frontend delivery by 30% using AI-driven UI generation."
    },
    {
      role: "Software Engineer",
      company: "Brand and Beyond OPC",
      companylogo: require("./assets/images/brand_and_beyondit_logo.jpg"),
      date: "Sep 2022 – Dec 2022",
      desc: "Spearheaded the development of comprehensive web solutions, overseeing both front-end and back-end architecture. Designed and built dynamic applications, collaborated with cross-functional teams, and integrated modern technologies to improve efficiency, scalability, and overall performance."
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/townbook.png"),
      projectName: "TownBook",
      projectDesc:
        "Developed a full-stack community library management platform for book catalog browsing, reading room reservations, and library administration.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://townbook-ritik.netlify.app"
        },
        {
          name: "Github",
          url: "https://github.com/codewithritik/TownBook"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/ai-summary.png"),
      projectName: "AI Text Summarizer Chrome Extension",
      projectDesc:
        "A Chrome extension that uses Google AI (Gemini) to summarize selected text on any webpage.",
      footerLink: [
        {
          name: "Demo Video",
          url: "https://drive.google.com/file/d/1zcruq6xuBWaXQX-Wpvpceqja6u7h0VO1/view?usp=sharing"
        },
        {
          name: "GitHub",
          url: "https://github.com/codewithritik/ai-text-summarizer"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/ai-chatbot.png"),
      projectName: "AI Company Chatbot ",
      projectDesc:
        "A full-stack web application that embeds an AI-powered chat widget on a site so visitors can ask questions in natural language and receive contextual, multi-turn replies backed by an LLM and optional document knowledge.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://snazzy-beignet-9feafa.netlify.app/"
        },
        {
          name: "Github",
          url: "https://github.com/codewithritik/ai-compnay-chatbot"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/appletv.png"),
      projectName: "AI Text Summarizer Chrome Extension",
      projectDesc:
        "Apple tv is a online Movie website you can Browse all movies, TV shows, and more from Apple TV+. Watch all Apple Originals here and on the Apple TV app across your devices.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://apple-tvclone.netlify.app/"
        },
        {
          name: "GitHub",
          url: "https://github.com/codewithritik/tvapple-Clone"
        }
        //  you can add extra buttons here.
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      imageAlt: "PWA Logo",
      footerLink: [
        { name: "Certification", url: "" },
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "About Me",
  subtitle: emoji(""),

  talks: [
    {
      title: "Mentored by Durlabh Jain",
      subtitle: "Gained expertise in Full Stack Development under his guidance",
      slides_url: "https://durlabhjain.com/", // Add any relevant link if needed
      event_url: "https://durlabhjain.com/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};


// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+91-9643943996",
  email_address: "ritikadvice@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
